import type { ComponentType, SVGProps } from 'react'

import {
  IconNavAgent,
  IconNavComic,
  IconNavCreate,
  IconNavLibrary,
  IconNavProfile,
  IconNavWorkflow,
} from '../components/nav-icons'
export type NavItem = {
  to: string
  label: string
  short: string
  desc: string
  Icon: ComponentType<SVGProps<SVGSVGElement>>
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/create', label: '生图', short: '生图', desc: '描述即画面', Icon: IconNavCreate },
  { to: '/comics', label: '漫画', short: '漫画', desc: '分册存放的故事', Icon: IconNavComic },
  { to: '/agents', label: '智能体', short: '智能体', desc: '目标驱动工具执行', Icon: IconNavAgent },
  { to: '/workflows', label: '工作流', short: '工作流', desc: 'AI 辅助编排', Icon: IconNavWorkflow },
  { to: '/library', label: '图库', short: '图库', desc: '分类与管理', Icon: IconNavLibrary },
  { to: '/profile', label: '我的', short: '我的', desc: '账户与积分', Icon: IconNavProfile },
]
